'use es6';

import * as TierGroups from 'ecosystem-marketplace-core/constants/groupTags/TierGroup';
export const flattenedTierOrder = [TierGroups.CRM, TierGroups.MARKETING, TierGroups.SALES, TierGroups.SERVICE, TierGroups.CMS, TierGroups.OPERATIONS].reduce((acc, val) => acc.concat(val), []);
export const sortTiers = (tierA, tierB) => flattenedTierOrder.indexOf(tierA) - flattenedTierOrder.indexOf(tierB);
export const getMinimumRequiredPlan = (integrationFeature, compatibility, portalTiers) => {
  if (!integrationFeature.get('hubSpotFeatures')) {
    return '';
  }

  return integrationFeature.get('hubSpotFeatures').reduce((minimumRequiredPlan, feature) => {
    const requiredTiers = compatibility.get(feature).filter(tier => flattenedTierOrder.includes(tier));

    if (!requiredTiers.size || !portalTiers.intersect(requiredTiers).isEmpty()) {
      // Current plan compatible with this feature
      return minimumRequiredPlan;
    } // Current plan incompatible, find lowest compatible plan


    return [...requiredTiers, ...(minimumRequiredPlan ? [minimumRequiredPlan] : [])].sort(sortTiers)[0];
  }, '');
};